import { render } from "./StandardTable.vue?vue&type=template&id=176c2abe&scoped=true"
import script from "./StandardTable.vue?vue&type=script&lang=js"
export * from "./StandardTable.vue?vue&type=script&lang=js"

import "./StandardTable.vue?vue&type=style&index=0&id=176c2abe&scoped=true&lang=css"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-view\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-176c2abe"]])

export default __exports__